export var BORDER_VALUE = "2px solid hsla(0, 0%, 0%, 0.1)";